import React from 'react';
import { useHistory } from 'react-router-dom';
import { useLanguage } from '../../i18n/LanguageContext';

function DeleteConfirmationModal({ onDelete, onCancel }) {
    const history = useHistory();
    const { t } = useLanguage();
    
    const handleJaClick = () => {
        // First perform the delete operation
        onDelete();
        // Then navigate to home page
        history.push('/');
    };
    
    return (
        <div style={{
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            backgroundColor: 'white',
            padding: '20px',
            border: '1px solid black',
            zIndex: 1000,
        }}>
            <p>{t('smallWidgets.deleteConfirm')}</p>
            <button onClick={handleJaClick} style={{ marginRight: '10px' }}>{t('smallWidgets.yes')}</button>
            <button onClick={onCancel}>{t('smallWidgets.no')}</button>
        </div>
    );
}

export default DeleteConfirmationModal;
